import produce, { Draft } from "immer";
import { combineReducers } from "redux";

import { ACTIONS, ActionType } from "actions/consents/types";
import { LoadingState } from "types/api";
import { UserConsent } from "./types";

const initialConsent = {
    status: LoadingState.idle,
};

const userConsent = produce((state: Draft<UserConsent>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_USER_CONSENT_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_USER_CONSENT_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        }
        case ACTIONS.GET_USER_CONSENT_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialConsent);

export default combineReducers({
    userConsent,
});
